/**
 * fetch the Apt as json for the view page
 * lruCache saves the last 10 apt/search requests
 */
/* @ngInject */
export function AptService($window, $http, lruCache) {
  return {
    get: function(aptId) {
      let url = __BACKEND__ + "/apt-json/" + aptId;
      if (!aptId) {
        throw new Error("Bad apt id" + aptId);
      }
      return $http
        .get(url, {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          cache: lruCache
        })
        .then(function(response) {
          return response.data;
        })
        .catch(function() {
          $window.location = $window.location.href;
        });
    }
  };
}
